import api from "api";
import BlockHeader from "component/BlockHeader/BlockHeader";
import fancybox from "component/Fancybox/Fancybox";
import { format, parseISO } from "date-fns";
import _ from "lodash";
import React, { useEffect } from "react";
import { useState } from "react";
import "./index.scss";
import {ReactComponent as SVGArrowUp} from '../../assets/arrow-up.svg';

const FAQPop = (props) => {
    return (
        <div className="component-faq-popup w-640">
            <BlockHeader title={props.faq.question} desc={`Last Update : ${format(parseISO(props.faq.last_update), 'dd LLLL Y HH:mm:ss')}`}/>
            <hr />
            <div className="wp-content" dangerouslySetInnerHTML={{__html : props.faq.answer}}></div>
        </div>
    )
}

const FAQList = (props) => {
    const [faqs, setFaqs] = useState(props.faqs || false);


    useEffect(() => {
        if(faqs !== false)
        {
            return;
        }

        api('/FAQ', 'get', {
            sticky : props.sticky || false
        })
            .then(response => {
                setFaqs(response.faq);
            })

    }, []);

    return (
        <div className="component-faq-list">
            <ul className="faqs">
                {
                    faqs !== false && faqs.map(faq => (
                        <li className="faq" key={faq.id}>
                            <a href="#" className="faq-wrapper" onClick={e => {
                                e.preventDefault();
                                
                                fancybox(
                                    <FAQPop faq={faq}/>
                                );
                            }}>
                                <span className="faq-title leading-text">
                                    {faq.question}
                                </span>
                            </a>
                        </li>
                    ))
                }
                {
                    faqs === false &&
                    <li className="faq">
                        <span className="faq-wrapper">
                            <span className="skeleton"></span>
                        </span>
                    </li>
                }
            </ul>
        </div>
    )
}

const FAQGroups = (props) => {
    const [faqs, setFaqs] = useState(false);

    useEffect(() => {
        if(faqs !== false)
        {
            return;
        }

        api('/FAQ', 'get', {})
            .then(response => {
                
                setFaqs( _.groupBy(response.faq, 'group') );
            })
    }, []);

    return (
        <div className="component-faq-groups">
            {
                faqs !== false && _.keys(faqs).map((faqGroupName) => (
                    <div className="faq-groups" key={faqGroupName}>
                        <span className="group-label block">
                            {faqGroupName}
                        </span>
                        <FAQList faqs={faqs[faqGroupName]} />
                    </div>
                ))
            }
            {
                faqs == false && 
                <span className="skeleton"></span>
            }
        </div>
    )
}

export {FAQList, FAQGroups};